export default __webpack_public_path__ + "static/media/eb-pro-blk-2.7901aa35.png";